import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0905Model } from './kymw0905.model';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { KYMW0905InputModel } from './vo/kymw0905-input.model';
import { KYMW0905OutputModel } from './vo/kymw0905-output.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { NotNullTextAreaComponent } from '../../kymw02/not-null-text-area/not-null-text-area.component';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';

/**
 * 商品企画栄養成分情報メンテナンス画面を管理するクラス
 *
 * @export KYMW0905Component
 * @class KYMW0905Component
 */
@Component({
  selector: 'app-kymw0905',
  templateUrl: 'kymw0905.component.html',
  styleUrls: ['kymw0905.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0905Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;
  // 親画面への連携値
  setKYMW0905Parameter: Function;

  kymw0905Model: KYMW0905Model = new KYMW0905Model();

  // 画面受渡情報
  // 画面呼び出し時に受け渡されるオブジェクト
  private inputVO: KYMW0905InputModel;

  // 権限「1」は閲覧モード「２」フルコントロール
  public funcPermission: string = <string>'2';

  // ０：使用不可、１：閲覧のみ、２：フルコントロール可能（帳票出力、更新）
  public enableMode: string = <string>'';

  @ViewChild('dg_NutrientComponentList', { static: true }) dg_NutrientComponentList: FlexGrid;
  @ViewChild('txta_NutritionalNote', { static: true }) txta_NutritionalNote: NotNullTextAreaComponent;
  @ViewChild('txta_AnalysisUnit', { static: true }) txta_AnalysisUnit: NotNullTextAreaComponent;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;
  selfManage: KYMW0905Model;

  /**
   *Creates an instance of KYMW0905Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0905Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  // eslint-disable-next-line
  public ngOnInit(): void {
    this.componentName = 'KYMW0905';
    // ヘッダー行の高さ
    this.dg_NutrientComponentList.columnHeaders.rows[0].height = 27;
    // 詳細行の高さ
    this.dg_NutrientComponentList.rows.defaultSize = 27;

    // 画面から引き渡された値をManageに反映させる
    this.kymw0905Model.orderCode = this.inputVO.orderCode;				            // 受注コード
    this.kymw0905Model.pCode = this.inputVO.pCode;					                  // Ｐコード
    this.kymw0905Model.itemCode = this.inputVO.itemCode;				              // アイテムコード
    this.kymw0905Model.guideGoodsName = this.inputVO.guideGoodsName;			    // 商品案内用商品名
    this.kymw0905Model.guideStandardName = this.inputVO.guideStandardName;  	// 商品案内用規格名
    this.kymw0905Model.analysisSeqNo = this.inputVO.analysisSeqNo;			      // 分析連番
    this.kymw0905Model.analysisUnit = this.inputVO.analysisUnit;			        // 分析単位
    this.kymw0905Model.nutritionalNote = this.inputVO.nutritionalNote;		  	// 栄養成分備考
    this.kymw0905Model.nutrientDetailList = this.inputVO.nutrientDetailList;  // 栄養成分リスト

    // ０：使用不可、１：閲覧のみ、２：フルコントロール可能（帳票出力、更新）
    this.enableMode = this.getFuncPermission('KYMW0900');
    this.kymw0905Model.funcPermission = this.funcPermission;

    // itemFormatterでセルの内容を変更
    this.dg_NutrientComponentList.itemFormatter = function (panel, r, c, cell) {
      // 全体的に左寄せ
      cell.style.textAlign = 'left';
      if (c === 0) {
        if (panel.rows[r].dataItem !== null) {
          // cellType 1:データセル 2:列ヘッダ 3:行ヘッダ 5:列フッタ
          // 仕様メモ:栄養成分名はコードで管理されている。またそのデータのRESEVER2が
          // 誌面表示かどうかを判断する値となり、serverから受け取る際にpublishDivとなる
          if ('1' === panel.rows[r].dataItem.publishDiv && panel.cellType === 1) {
            cell.style.color = 'Red';
          }
        }
      }
    };
    // 項番2231 START 障害管理No.U01316対応
    this.dg_NutrientComponentList.itemsSourceChanged.addHandler(() => {
      this.dg_NutrientComponentList.select(-1, -1);
      this.txta_AnalysisUnit.setFocus();
    });
    // 項番2231 END 障害管理No.U01316対応
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0905Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = <KYMW0905InputModel>param;
  }

  /**
		 * 項目変更時イベント
		 */
  public eventEditHandler(event: Event): void {
    this.kymw0905Model.isEdited = true;
  }

  /**
   * 「閉じる」
   *
   * @param event コールバック・イベントへの参照
   */
  public eventClose_CLICKHandler(): void {
    // 編集が行われている場合、メッセージを表示
    if (this.kymw0905Model.isEdited) {
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['栄養成分情報'], (closeEvent: number) => {
        if (closeEvent === PlessAlert.Yes) {
          // eventCloseHandler();
          this.closeFunction();
        }
      });
    } else {
      this.closeFunction();
    }
  }

  /**
		 * 設定ボタンを押下したときに呼び出されるメソッド。
		 *
		 * @param event コールバック・イベントへの参照
		 */
  public eventSet_CLICKHandler(event: Event): void {
    // 編集有無の確認
    if (!this.kymw0905Model.isEdited) {
      this.dialogServiceSub.openAlertGetMessage('E0162');
      return;
    }

    // 項番1925 START 障害管理NO.S00087対応
    // 商品栄養成分リストの栄養成分値すべてにデータがなかった場合
    if (!this.hasAnyDataInNutrientComponentList() && PlessViewUtilsSub.isEmpty(this.kymw0905Model.nutritionalNote)) {
      this.dialogServiceSub.openAlertGetMessage('E0250', ['栄養成分値、または栄養成分備考']);
      return;
    }
    // 項番1925 END 障害管理NO.S00087対応

    // 必須項目のチェック
    // 分析単位
    if (PlessViewUtilsSub.isEmpty(this.kymw0905Model.analysisUnit)) {
      this.dialogServiceSub.openAlertGetMessage('E0110', ['分析単位']);
      return;
    }

    const vo: KYMW0905OutputModel = new KYMW0905OutputModel();
    vo.editMode = this.inputVO.editMode;						// 編集モード
    vo.orderCode = this.inputVO.orderCode;
    vo.pCode = this.inputVO.pCode;
    vo.itemCode = this.inputVO.itemCode;
    // 項番2231 START 障害管理No.U01954対応
    // vo.analysisSeqNo = this.inputVO.analysisSeqNo;
    vo.analysisSeqNo = this.kymw0905Model.analysisSeqNo;
    // 項番2231 START 障害管理No.U01954対応
    vo.analysisUnit = this.txta_AnalysisUnit.text;
    vo.nutritionalNote = this.txta_NutritionalNote.text;
    vo.analysisUnit = vo.analysisUnit.replace(/(\n|\r|\0|\x0B)/gm, '');
    vo.nutritionalNote = vo.nutritionalNote.replace(/(\n|\r|\0|\x0B)/gm, '');

    const tempNutrientList: any = [];
    for (let i = Number(0); i < this.kymw0905Model.nutrientDetailList.length; i++) {      // 商品栄養成分リスト要素数分ループする
      // ArrayCollectionに追加するVOの生成
      const tempVO: any = [];
      tempVO.orderCode = this.inputVO.orderCode;                                                  // 受注コード
      tempVO.pCode = this.inputVO.pCode;                                                          // Ｐコード
      tempVO.itemCode = this.inputVO.itemCode;                                                    // アイテムコード
      // 項番2231 START 障害管理No.U01954対応
      // tempVO.analysisSeqNo = this.inputVO.analysisSeqNo;                                          // 分析連番
      tempVO.analysisSeqNo = this.kymw0905Model.analysisSeqNo;                                    // 分析連番
      // 項番2231 START 障害管理No.U01954対応
      tempVO.nutritionalCode = this.kymw0905Model.nutrientDetailList[i].NutritionalCode;          // 栄養成分コード
      tempVO.nutritionalName = this.kymw0905Model.nutrientDetailList[i].NutritionalName;          // 栄養成分名
      tempVO.nutritionalQuantity = this.kymw0905Model.nutrientDetailList[i].NutritionalQuantity;  // 栄養成分値
      tempVO.nutritionalUnit = this.kymw0905Model.nutrientDetailList[i].NutritionalUnit;          // 栄養成分単位
      tempVO.publishDiv = this.kymw0905Model.nutrientDetailList[i].PublishDiv;                    // 表示区分（0：誌面表示なし、1：あり）
      tempVO.hirearchy = this.kymw0905Model.nutrientDetailList[i].Hirearchy;                      // 階層
      tempNutrientList.push(tempVO);
    }

    vo.nutrientDetailList = tempNutrientList;

    this.kymw0905Model.isEdited = false;

    // 項番2231 START 障害管理No.U01954対応
    // 連番をインクリメント
    if (this.inputVO.multiFlag) {
      this.kymw0905Model.analysisSeqNo = String(Number(this.kymw0905Model.analysisSeqNo) + 1);
    }
    // 項番2231 START 障害管理No.U01954対応

    // 親画面に反映
    this.setKYMW0905Parameter(vo);
  }

  /**
	 * 栄養成分にデータがあるかどうか判断する。
	 */
  private hasAnyDataInNutrientComponentList(): boolean {
    for (let i = Number(0); i < this.kymw0905Model.nutrientDetailList.length; i++) {
      // 項番2231 START 障害管理NO.U01157対応
      // if (this.kymw0905Model.nutrientDetailList[i].NutritionalQuantity != null
      //   && this.kymw0905Model.nutrientDetailList[i].NutritionalQuantity !== '') {
      if (!PlessViewUtilsSub.isEmpty(this.kymw0905Model.nutrientDetailList[i].NutritionalQuantity)) {
        // 項番2231 END 障害管理NO.U01157対応
        return true;
      }
    }
    return false;
  }

  // 項番2231 START 連合会管理NO.16対応
  public nextFocus(event: any): void {
    // 次項目移動の場合（Shiftキー押下時は逆移動の為、制御しない）
    if (event.keyCode === 9 && !event.shiftKey) {
      event.preventDefault();
      // 行が選択されていない場合は1行目を選択状態にする
      if (this.dg_NutrientComponentList.selection.row < 0) {
        this.dg_NutrientComponentList.select(0, 1);
      }
      // 選択行を編集モードに変更する
      this.dg_NutrientComponentList.startEditing(true, this.dg_NutrientComponentList.selection.row, 1, true);
    }
  }
  // 項番2231 END 連合会管理NO.16対応

  /**
   * 栄養成分値をフォーカスアウトしたときに呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   * @param rowIndex 選択した行番号
   */
  public eventQuantity_FOCUSOUTHandler(event: any, cell: any): void {
    const input = event.target as HTMLInputElement;
    if(!input || !cell) {
      return;
    }

    // 入力した文字列の最後の半角/全角スペースを除去
    const strWrd = PlessViewUtilsSub.trimDirection(input.value, 1);
    input.value = strWrd;
    cell.value = strWrd;
    this.dg_NutrientComponentList.setCellData(cell.row.index, 'NutritionalQuantity', strWrd, true);
  }
}
